import cx from 'classnames';

import { APP_LOGO_VARIANT, AppLogo } from 'src/components/AppLogo';
import { useIsCustomerLocked } from 'src/services';

import { CreateContentItem } from './views/CreateContentItem';
import { DashboardItem } from './views/DashboardItem';
import { FolderItems } from './views/FolderItems';
import { SidebarItems } from './views/SidebarItems';
import { TrialProgress } from './views/TrialProgress/TrialProgress';
import { WorkspaceItem } from './views/WorkspaceItem';
import { useSidebarEvents } from './service';
import { useStyles } from './useStyles';

export const NavigationSidebarPanel = ({ className }) => {
  const styles = useStyles();

  const isCustomerLocked = useIsCustomerLocked();
  const { trackNavigationItemClicked } = useSidebarEvents();

  return (
    <div
      className={cx(styles.root, className)}
      data-testid="navigationSidebarPanel"
    >
      <div className={styles.logoWrapper}>
        <AppLogo
          className={styles.logo}
          variant={APP_LOGO_VARIANT.light}
          onClick={() => {
            trackNavigationItemClicked({ label: 'App logo' });
          }}
        />
      </div>

      {!isCustomerLocked && (
        <>
          <CreateContentItem className={styles.createContentItem} />

          <div className={styles.scrollable}>
            <DashboardItem className={styles.homeItem} />
            <FolderItems className={styles.folderItems} />

            <div className={styles.divider} />

            <SidebarItems className={styles.sidebarItems} />
            <TrialProgress className={styles.trialProgress} />
          </div>

          <WorkspaceItem className={styles.workspaceItem} />
        </>
      )}
    </div>
  );
};
